var map = {
	"./__mocks__/de.json": [
		"N1rJ",
		5114
	],
	"./__mocks__/en.json": [
		"fZmO",
		3982
	],
	"./__mocks__/fr.json": [
		"NyLw",
		6751
	],
	"./__mocks__/nl.json": [
		"39yp",
		1762
	],
	"./de.json": [
		"eILv",
		5083
	],
	"./en.json": [
		"1reX",
		233
	],
	"./fr.json": [
		"/aXd",
		5579
	],
	"./it.json": [
		"XWbp",
		9450
	],
	"./nl.json": [
		"jmDP",
		7528
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "x6RNX";
module.exports = webpackAsyncContext;